import React, { useState } from 'react'

import { AcornsIcon } from '@acorns/icons'

import { PageName } from 'generated/types'
import { TestIDs } from 'test/utils/testIds'
import trackEvent from 'utils/analytics/trackEvent'
import { isEqualWebScriptLoaded, loadEqualWebScript, showEqualWebWidget } from 'vendors/equalweb'

import { getAccessibilityEventData } from './events'
import { Container, WhiteAccessibilityIcon } from './styled-components'

interface Props {
  pageName: PageName
  eventObjectName: string
  isMainSignUpPage?: boolean // this should only be used for the email/password screens
  hasBackgroundColor?: boolean
}

export const Accessibility = (props: Props) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = () => {
    if (isLoading) return

    if (isEqualWebScriptLoaded()) {
      showEqualWebWidget()
    } else {
      setIsLoading(true)
      loadEqualWebScript()
      // istanbul ignore next ignoring coverage due to interval setting, we are checking if script loads in tests
      const checkEqualWebLoadedInterval = setInterval(() => {
        if (isEqualWebScriptLoaded()) {
          clearInterval(checkEqualWebLoadedInterval)
          setIsLoading(false)
          showEqualWebWidget()
        }
      }, 500)
    }

    trackEvent('Button Tapped', {
      eventData: getAccessibilityEventData({
        pageName: props.pageName,
        isMainSignUpPage: props.isMainSignUpPage,
        eventObjectName: props.eventObjectName,
      }),
    })
  }
  return (
    <Container data-testid={TestIDs.ACCESSIBILITY.BUTTON} onClick={handleClick}>
      {props.hasBackgroundColor ? (
        <WhiteAccessibilityIcon id="equal-web-toggle" aria-label="Open Accessibility Menu" />
      ) : (
        <AcornsIcon
          icon={AcornsIcon.Icon.UtilityAccessibilityFv}
          width="24px"
          height="24px"
          id="equal-web-toggle"
          aria-label="Open Accessibility Menu"
        />
      )}
    </Container>
  )
}
